import React from 'react';
import { useRoutes } from 'react-router-dom';
import '../src/main/styles/common.scss';

import Home from './main/pages/Home';
import { ProtectedRoute } from './main/components/ProtectedRoute';

const Editor = React.lazy(() => import('./main/pages/Editor'));

const App: React.FC = (): JSX.Element => {
    const mainRoutes = {
        path: '/',
        element: <Home />,
        children: [
            { path: '*', element: <Home /> },
            { path: '/', element: <Home /> },
        ],
    };
    const editorRoutes = {
        path: 'editor',
        element: (
            <ProtectedRoute>
                <Editor />
            </ProtectedRoute>
        ),
        children: [
            { 
                path: 'editor', 
                element: (
                    <ProtectedRoute>
                        <Editor />
                    </ProtectedRoute>
                ) 
            },
            { 
                path: ':id', 
                element: (
                    <ProtectedRoute>
                        <Editor />
                    </ProtectedRoute>
                ) 
            },
        ],
    };
    const routing = useRoutes([mainRoutes, editorRoutes]);

    return <>{routing}</>;
};

export default App;